import React from "react";
import { View, Text, StyleSheet, TouchableOpacity } from "react-native";

import {
  CreateResponsiveStyle,
  DEVICE_SIZES,
  useDeviceSize,
} from "rn-responsive-styles";
import { AppFontStyle } from "../../../../styles/AppFontStyle";
import { AppColors } from "../../../../utility/AppColors";

const PaidStreamingTimerComponent = ({
  isMoreTimeLeft,
  isMinAttendees,
  timeLeft,
  requiredAttendees,
  totalAttendees,
  showTimer,
  formattedDate,
  title,
  type,
  IsEventCanceled,
  IsEventCompleted,
}) => {
  const deviceSize = useDeviceSize();
  const styles = useStyles();

  // Format time values to always show two digits
  const formatTime = (value) => String(value).padStart(2, "0");

  // Determine message and color based on conditions
  const isTimeUp = !isMoreTimeLeft || (timeLeft?.days === 0 && timeLeft?.hours === 0 && timeLeft?.minutes === 0 && timeLeft?.seconds === 0);
  const isSoldOut = isMinAttendees && isMoreTimeLeft;
  const isTimeExtended = !isMoreTimeLeft && timeLeft?.hours === 23 && timeLeft?.minutes === 59 && timeLeft?.seconds === 59; // Assuming extension adds 24h

  let message = "Event tickets are in sale";
  let messageColor = "#FFFFFF";
  if (isSoldOut) {
    message = "Event tickets are sold out";
    messageColor = AppColors.appGreenColor_51AF07;
  } else if (isTimeUp && !isMinAttendees) {
    message = "Event tickets Time limit reached";
    messageColor ="#AF0707";
  } else if (isTimeExtended) {
    message = "Event tickets Time expended by 24 hours";
    messageColor = AppColors.appGreenColor_51AF07;
  }

  // Calculate progress width (scaled to maxWidth of 100 pixels)
  const maxWidth = 100;
 
  const remainingAttendees =  requiredAttendees - totalAttendees ;
console.log("remainingAttendees",remainingAttendees);

  return (
    <View style={{ justifyContent: "space-between" }}>
      <View style={styles.container}>
        {/* Event Title and Message */}
        <Text style={styles.eventTitle}>[{title || "Event Name"}]</Text>
        <Text style={[styles.message, { color: messageColor }]}>{message}</Text>

        {/* Countdown Timer */}
        <View style={styles.timerRow}>
          {["days", "hours", "minutes", "seconds"].map((unit, index) => (
            <View key={index} style={{ backgroundColor: isTimeUp ? "#AF0707": "#1E1E1E",
              borderRadius: 8,
              padding: 10,
              alignItems: "center",
              width: 60,}}>
              <Text style={styles.timerText}>
                {formatTime(timeLeft?.[unit] || 0)}
              </Text>
              <Text style={styles.timerLabel}>
                {unit.charAt(0).toUpperCase() + unit.slice(1)}
              </Text>
            </View>
          ))}
        </View>

        {/* Extend Time and Continue Buttons (shown when time is up and not enough attendees) */}
        {isTimeUp && !isMinAttendees && !IsEventCanceled && !IsEventCompleted && (
          <View style={styles.buttonRow}>
            <TouchableOpacity style={styles.button}>
              <Text style={styles.buttonText}>Extend time by 24h</Text>
            </TouchableOpacity>
            <TouchableOpacity style={[styles.button, styles.continueButton]}>
              <Text style={styles.buttonText}>Continue anyway</Text>
            </TouchableOpacity>
          </View>
        )}
      </View>
      <View>
        {/* Progress Bar */}
        <View style={styles.progressContainer}>
          <View style={styles.progressBackground}>
          <View
              style={[
                styles.progressFill,
                { width: `${totalAttendees || 0}%` },
              ]}
            />
          </View>
          <Text style={styles.progressText}>
            {totalAttendees || 0}/{requiredAttendees || 100}
          </Text>
        </View>

        {/* Additional Message */}
        <Text style={styles.additionalMessage}>
          {remainingAttendees} more attendees needed for this event to go ahead
        </Text>
      </View>
    </View>
  );
};

const useStyles = CreateResponsiveStyle(
  {
    container: {
      backgroundColor: "#121212",
      borderRadius: 24,
      padding: 20,
      width: 446,
    },
    eventTitle: {
      ...AppFontStyle.BOLD_ANYBODY_24,
      color: AppColors.white,
      marginBottom: 20,
    },
    message: {
      ...AppFontStyle.REGULAR_ANYBODY_20,
      marginBottom: 15,
    },
    timerRow: {
      flexDirection: "row",
      justifyContent: "space-between",
      width: "100%",
      marginBottom: 20,
    },
    // timerBox: {
    //   backgroundColor: isTimeUp ? "#AF0707": "#1E1E1E",
    //   borderRadius: 8,
    //   padding: 10,
    //   alignItems: "center",
    //   width: 60,
    // },
    timerText: {
      ...AppFontStyle.BOLD_ANYBODY_20,
      color: AppColors.white,
    },
    timerLabel: {
      ...AppFontStyle.REGULAR_ANYBODY_10,
      color: AppColors.white,
      marginTop: 5,
    },
    buttonRow: {
      flexDirection: "row",
      justifyContent: "space-between",
      marginTop: 10,
    },
    button: {
      backgroundColor: AppColors.purpleColor_9D2CF5,
      borderRadius: 8,
      paddingVertical: 8,
      paddingHorizontal: 15,
      flex: 1,
      marginRight: 10,
    },
    continueButton: {
      backgroundColor: AppColors.purpleColor_9D2CF5,
    },
    buttonText: {
      ...AppFontStyle.REGULAR_ANYBODY_14,
      color: AppColors.white,
      textAlign: "center",
    },
    progressContainer: {
      width: "100%",
      marginBottom: 10,
    },
    progressBackground: {
      height: 12,
      backgroundColor: AppColors.gray_C4C4C4,
      borderRadius: 4,
      overflow: "hidden",
    },
    progressFill: {
      height: "100%",
      backgroundColor: AppColors.appGreenColor_51AF07,
      borderRadius: 4,
    },
    progressText: {
      ...AppFontStyle.REGULAR_ANYBODY_12,
      color: AppColors.white,
      textAlign: "right",
      marginTop: 5,
    },
    additionalMessage: {
      ...AppFontStyle.REGULAR_ANYBODY_12,
      color: AppColors.white,
      textAlign: "center",
    },
  },
  {
    [DEVICE_SIZES.XS]: {
      container: {
        padding: 15,
      },
      eventTitle: {
        ...AppFontStyle.BOLD_ANYBODY_14,
      },
      message: {
        ...AppFontStyle.REGULAR_ANYBODY_12,
      },
      // timerBox: {
      //   width: 50,
      //   padding: 8,
      // },
      timerText: {
        ...AppFontStyle.BOLD_ANYBODY_18,
      },
      timerLabel: {
        ...AppFontStyle.REGULAR_ANYBODY_8,
      },
      button: {
        paddingVertical: 6,
        paddingHorizontal: 10,
      },
      buttonText: {
        ...AppFontStyle.REGULAR_ANYBODY_12,
      },
    },
    [DEVICE_SIZES.SM]: {
      container: {
        padding: 15,
      },
      eventTitle: {
        ...AppFontStyle.BOLD_ANYBODY_14,
      },
      message: {
        ...AppFontStyle.REGULAR_ANYBODY_12,
      },
      // timerBox: {
      //   width: 50,
      //   padding: 8,
      // },
      timerText: {
        ...AppFontStyle.BOLD_ANYBODY_18,
      },
      timerLabel: {
        ...AppFontStyle.REGULAR_ANYBODY_8,
      },
      button: {
        paddingVertical: 6,
        paddingHorizontal: 10,
      },
      buttonText: {
        ...AppFontStyle.REGULAR_ANYBODY_12,
      },
    },
    [DEVICE_SIZES.MD]: {
      container: {
        padding: 20,
      },
    },
    [DEVICE_SIZES.LG]: {
      container: {
        padding: 20,
      },
    },
  }
);

export default PaidStreamingTimerComponent;